// store.js
// import { reactive } from 'vue'
import Vue from "vue";
import Vuex from "vuex";
import api from './api.js'
// export const store = reactive({
//     headerXml: '',
//     footerXml: '',
//     lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'zn',
//     updateLang(lang,i18n){
//       this.lang = lang
//       i18n.locale = lang
//       localStorage.setItem("lang",lang)
//     },
//     updateXml(){
//         api.getFooterHeader().then(res => {
//             this.headerXml = res.header
//             this.footerXml = res.footer
//         })
//     }
// })
Vue.use(Vuex);
 const store = new Vuex.Store({
   state: {
     headerXml: "",
     footerXml: "",
     lang: localStorage.getItem("lang") ? localStorage.getItem("lang") : "zn",
   },
   mutations: {
     setHeaderXml(state, headerXml) {
       state.headerXml = headerXml;
     },
     setFooterXml(state, footerXml) {
       state.footerXml = footerXml;
     },
     setLang(state, lang) {
       state.lang = lang;
       localStorage.setItem("lang", lang);
     },
   },
   actions: {
     updateLang({ commit }, { lang, i18n }) {
       commit("setLang", lang);
       i18n.locale = lang;
     },
     updateXml({ commit }) {
       api.getFooterHeader().then(res => {
         commit("setHeaderXml", res.header);
         commit("setFooterXml", res.footer);
       });
     },
   },
   getters: {
     currentLang: state => state.lang,
   },
 });
export default store;
